import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-popin-photo',
  templateUrl: './popin-photo.component.html',
  styleUrls: ['./popin-photo.component.css']
})
export class PopinPhotoComponent implements OnInit {
  @Input()
  acceptFunction;
  @Input()
  deniedFunction;
  @Input()
  message: string;
  @Input()
  titre: string;

  @Output() clicked = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit() {
  }

  acceptRemoteFunction() {
    this.acceptFunction();
    this.clicked.emit(true);
  }

  deniedRemoteFunction() {
    this.deniedFunction();
    this.clicked.emit(false);
  }


}



// WEBPACK FOOTER //
// ./src/app/photo/popin-photo/popin-photo.component.ts